export default "https://cdn-static.gokick.com/assets/96917af4b324ebd1ae50a0309f8a33967fe87b4d/images/choco-chill.d2e5a3cb4eac031c8a1d2dbef046a05a.png";